import { apiClient } from './apiClient';

export interface NotificationPreferences {
    _id: string;
    userId: string;
    planning: boolean;
    gnr: boolean;
    forms: boolean;
    needs: boolean;
    reports: boolean;
    securityPassport: boolean;
}

export const getNotificationPreferences = async (): Promise<{ data: NotificationPreferences }> => {
    const response = await apiClient.get('/notifications/preferences');
    return response.data;
};

export const updateNotificationPreferences = async (
    updates: Partial<Omit<NotificationPreferences, '_id' | 'userId'>>
): Promise<{ data: NotificationPreferences }> => {
    const response = await apiClient.patch('/notifications/preferences', updates);
    return response.data;
};
